import { Logger } from "effect"

export const browserLogger = Logger.replace(
  Logger.defaultLogger,
  Logger.withLeveledConsole(Logger.stringLogger)
)
